<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
	<v-container class="space-y-xl px-sm md:px-0">
		<div class="space-y-md">
			<v-h3 tag="h1">
				{{ blokData.title }}
			</v-h3>
		</div>

		<iframe
			class="iframe"
			allow="fullscreen"
			:title="blokData.title"
			:src="blokData.iframe_url"
		></iframe>
	</v-container>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "storyblok-js-client";

const properties = defineProps<{
	story: ISbStoryData;
}>();

const blokData = reactive(properties.story.content);
</script>

<style lang="scss">
.iframe {
	border: 0;
	height: calc(100vh - 64px);
	vertical-align: top;
	width: 100%;
}
</style>
